import { ObjSerUtils } from "DiscoveryEngine.TS/Serialization";
import { DtoBase, HashSet } from "DiscoveryEngine.TS/Utils";


export class GetSlackInfoResultDto extends DtoBase {

    public Webhooks: string;

    constructor() {
        super();

		this.Webhooks = "";
    }

	public get HasWebhooks(): boolean {
		return (!!this.Webhooks);
    }
 
	public Write(obj: any, context: any): void {
		obj.get_slack_info_result = {};
		obj = obj.get_slack_info_result;

		super.Write(obj, context);

		if (this.HasWebhooks) {
			obj.webhooks = this.Webhooks;
		}
	}

	public Read(obj: any, context: any): void {
		if (!obj.get_slack_info_result)
			throw new Error();
		obj = obj.get_slack_info_result;

		super.Read(obj, context);

		if (obj.webhooks !== undefined)
			this.Webhooks = obj.webhooks;
	}

}